{
    "common": {
        "mon": "Mån",
        "tue": "Tis",
        "wed": "Ons",
        "thu": "Tor",
        "fri": "Fre",
        "sat": "Lör",
        "sun": "Sön",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dec",
        "january": "Januari",
        "february": "Februari",
        "march": "Mars",
        "april": "April",
        "may": "Maj",
        "june": "Juni",
        "july": "Juli",
        "august": "Augusti", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "December",
        "checkin": "Incheckning",
        "checkout": "Utcheckning",
        "room": "Rum",
        "rooms": "Rum",
        "adult": "Vuxen",
        "adults": "Vuxna",
        "edit": "Redigera",
        "editCap": "REDIGERA",
        "delete": "Radera",
        "deleteCap": "RADERA",
        "localTime": "Lokal Tid",
        "back": "TILLBAKA",
        "home": "HEM",
        "yes": "JA",
        "no": "NEJ",
        "left": "Kvar",
        "hour": "Timme",
        "hours": "Timmar",
        "night": "natt",
        "nights": "nätter",
        "for": "för",
        "why": "Varför",
        "get": "Få",
        "more": "Mer",
        "agree": "GODKÄNN",
        "disagree": "AVBÖJ",
        "basedOn": "baserat på",
        "error": "Ett fel uppstod, försök igen senare",
        "error2": "Misslyckades, försök igen!",
        "error3": "Ett fel uppstod!!",
        "error4": "Ett fel uppstod!! Försök igen",
        "error5": "Förlåt!! Ett fel uppstod. Försök igen senare.",
        "hi": "Hej",
        "to": "till",
        "free": "Gratis",
        "per": "Per",
        "at": "kl",
        "day": "Dag",
        "days": "Dagar",
        "time": "Tid",
        "of": "av",
        "photo": "Foto",
        "photos": "Foton",
        "done": "Klar",
        "fullStay": "Hela Vistelsen",
        "date": "Datum",
        "and": "och",
        "bookingDetail": "Bokningsdetaljer",
        "Back": "Tillbaka",
        "Home": "Hem"
    },
    "userPopup": {
        "myAccount": "Mitt Konto",
        "welcome": "Välkommen",
        "user": "Användare",
        "findMyBookings": "HITTA MINA BOKNINGAR",
        "viewProfile": "VISA PROFIL",
        "makeAReservarion": "GÖR EN RESERVATION",
        "logout": "LOGGA UT",
        "loginCap": "LOGGA IN",
        "login": "Logga in",
        "invalidCredentials": "Ogiltiga inloggningsuppgifter",
        "invalidEmail": "Ogiltig e-post",
        "passwordIsRequired": "Lösenord krävs",
        "minChar8": "minst 8 tecken",
        "tooShort": "För Kort!",
        "tooLong": "För Långt!",
        "required": "Obligatoriskt",
        "emailInvalid": "Ange en giltig e-post",
        "passwordInvalid": "Ange ett giltigt lösenord",
        "phNumInvalid": "Telefonnumret är inte giltigt",
        "signupCap": "REGISTRERA DIG",
        "signup": "Registrera dig",
        "verifyText": "Verifiera att det är du",
        "verifyText2": "Vi har skickat en verifieringskod till din e-post",
        "verificationCode": "Verifieringskod",
        "didNotReceiveEmail": "Fick du inget e-postmeddelande",
        "clickToResend": "Klicka för att skicka igen",
        "verifyAndSignIn": "Verifiera och Logga in",
        "otpSentSuccessfully": "OTP skickades framgångsrikt",
        "somethingWentWrong": "Något gick fel, försök igen",
        "otpError": "Ange ett giltigt nummer",
        "otpError2": "Ange endast siffror",
        "otpError3": "Felaktig OTP, försök igen",
        "otpError4": "OTP har gått ut, klicka på Skicka igen",
        "otpError5": "Försök igen",
        "forgetPassword": "Glömt Lösenord",
        "submitError": "Användaren finns inte!",
        "userExistError": "Användaren Finns Redan",
        "checkYourEmail": "Kontrollera din e-post",
        "passwordResetLinkSent": "Vi har skickat en länk för lösenordsåterställning till",
        "noWorriesResetInstructions": "Inga problem, vi skickar dig återställningsinstruktioner.",
        "enterYourEmail": "Ange din e-post",
        "resetMyPassword": "ÅTERSTÄLL MITT LÖSENORD",
        "setANewPassword": "Ange ett nytt lösenord",
        "newPassword": "Nytt Lösenord",
        "confirmPassword": "Bekräfta Lösenord",
        "confirmPasswordError": "Lösenorden måste matcha",
        "backToLogin": "Tillbaka till Inloggning",
        "dontHaveAccount": "Har du inget konto?",
        "alreadyHaveAccount": "Har du redan ett konto?",
        "memberDiscount1": "Du kommer att få",
        "memberDiscount2": "medlemsrabatt för alltid.",
        "discount1": "Hantera alla dina reservationer på ett ställe.",
        "discount2": "Registrera dig för personliga rekommendationer och skräddarsydda upplevelser!!",
        "discount3": "Gå med i vår community av nöjda gäster och börja planera din vistelse.",
        "leftGridText1": "Hantera alla dina reservationer på ett ställe",
        "leftGridText2": "Registrera dig för personliga rekommendationer och skräddarsydda upplevelser!!",
        "leftGridText3": "Gå med i vår community av nöjda gäster och börja planera din vistelse",
        "gridDiscountText1": "medlemsrabatt på",
        "gridDiscountText2": "utvalda fastigheter för alltid",
        "gridDiscountText3": "Logga in för en skräddarsydd upplevelse för alltid",
        "gridDiscountText4": "Få Exklusiva Medlemsförmåner",
        "findBookingError": "Din e-post och boknings-ID matchar inte",
        "verifyAndConfirmBooking": "Verifiera och bekräfta bokning",
        "confirmEmailText": "Vi har skickat en verifieringskod till din e-postadress",
        "enterCodeText": "Ange verifieringskoden som skickats till dig",
        "didNotRecieveEmail": "Fick du inget e-postmeddelande?",
        "changeEmailText": "Klicka här för att ändra e-postadressen",
        "verifyAndConfirm": "Verifiera och Bekräfta",
        "verified": "VERIFIERAD",
        "bookingExpired": "Bokning Utgången",
        "bookingExpiredText": "Vi beklagar, boknings-ID du använder har gått ut",
        "backToFindingBooking": "Tillbaka till Hitta Bokning",
        "findMyBooking": "Hitta Mina Bokningar",
        "bookingEmail": "Boknings E-post",
        "reservationId": "Reservations-ID",
        "findBooking": "HITTA BOKNING",
        "abandonmentCartDoneText1": "Tack!",
        "abandonmentCartDoneText2": "Dina kundvagnsdetaljer har skickats till e-posten. Fortsätt din bokning när som helst.",
        "Recommended Currencies": "Rekommenderade Valutor",
        "All currencies": "Alla valutor",
        "thisIsRequiredField": "Detta är ett obligatoriskt fält"
    },
    "widget": {
        "destination": "Destination",
        "enterDestination": "Ange Destination",
        "guests": "Gäster",
        "guest": "Gäst",
        "nationality": "Nationalitet",
        "selectNationality": "Välj nationalitet",
        "nationalityIsRequired": "Nationalitet krävs",
        "selectedRate": "Specialpris",
        "search": "Sök",
        "ages": "Åldrar",
        "orAbove": "Eller Äldre",
        "child": "Barn",
        "children": "Barn",
        "addAnotherRoom": "Lägg Till Ett Rum Till",
        "removeRoom": "Ta Bort Rum",
        "property": "Boende",
        "city": "Stad",
        "country": "Land",
        "bookNow": "Boka Nu",
        "overnightStay": "Övernattning",
        "dayUse": "Dagsanvändning",
        "destinationIsRequired": "Destination krävs",
        "checkInIsRequired": "Incheckningsdatum krävs",
        "checkOutIsRequired": "Utcheckningsdatum krävs",
        "noLocationFound": "Ingen Plats Hittades",
        "soldOut": "Slutsålt",
        "highDemand": "Hög Efterfrågan",
        "dates": "Datum",
        "allRates": "Alla priser är i",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Utcheckning samma dag"
    },
    "promotion": {
        "headingText": "Viktig Information för",
        "regularRate": "Ingen",
        "seniorCitizen": "Seniorpris",
        "agencyRate": "Byråpris",
        "caaRate": "CAA/AAA Pris",
        "corporateRate": "Företagspris",
        "governmentRate": "Myndighets/Militärpris",
        "promotionalSpecialRate": "Kampanj/Specialpris",
        "regularRateDescription": "Ingen kampanj tillämpad.",
        "seniorCitizenRateDescription": "Detta är ett rabatterat hotellpris som är tillgängligt för äldre vuxna, vanligtvis 60 år eller äldre.",
        "agencyRateDescription": "Detta är ett rabatterat hotellpris som endast kan nås genom specifika resebyråer för att främja partnerskap och samarbete.",
        "caaRateDescription": "Detta är ett särskilt hotellpris som erbjuds till medlemmar i AAA eller CAA för exklusiva besparingar.",
        "corporateRateDescription": "Detta är ett rabatterat hotellpris som erbjuds till affärsresenärer, vanligtvis förhandlat mellan hotellet och företaget.",
        "governmentRateDescription": "Denna prisplan erbjuder specifika rabatter för myndighets-/militärpersonal för att boka ett hotellrum.",
        "contentSeniorCitizen": "Födelsedatumsbevis är obligatoriskt vid incheckning. Om du inte kan visa relevant ID kommer gällande priser att debiteras.",
        "contentAgencyRate": "Se till att ha din bokningsbekräftelse och ID-bevis vid ankomst. Om du inte kan visa dessa kommer standardpriser att tillämpas.",
        "contentPromotionalSpecialRate": "Detta är ett rabatterat hotellpris som erbjuds under begränsad tid, ofta kopplat till specifika evenemang, säsonger eller marknadsföringskampanjer.",
        "contentCaaRate": "Vänligen se till att du har ditt CAA-medlemskort eller relevant identifikation vid incheckning. Om du inte kan visa relevant ID kommer gällande priser att debiteras.",
        "contentCorporateRate": "Bevis på företags-ID eller annan officiell dokumentation krävs vid incheckning. Om du inte kan visa relevant bevis kommer gällande priser att debiteras.",
        "contentGovernmentRate": "Giltigt myndighets- eller militär-ID måste uppvisas vid incheckning. Om du inte kan tillhandahålla den nödvändiga identifikationen kommer standardpriser att debiteras.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "TILLÄMPA",
        "Offer Code": "Erbjudandekod",
        "Agency Code": "Byråkod",
        "Corporate Code": "Företagskod",
        "All-Access Rate": "All-Access Pris",
        "errorCode": "Denna kod är inte giltig"
    }
}
